import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "15",
  fill: "none",
  viewBox: "0 0 15 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-width": "4",
      d: "m3 12 7.649 10.348a1 1 0 0 0 1.639-.044L25 3"
    }, null, -1)
  ])))
}
export default { render: render }